import React, { MouseEvent } from "react";
import { Timeslot } from "types";
import { EventNotesModal } from "../../Event/EventNotesModal";
import { NotesBadge } from "../Common/NotesBadge";
import { DashboardItemActionButtons } from "../DashboardItemActionButtons";
import { useModal } from "@/hooks/useVisibility";

interface NotesButtonsDisplayProps {
    timeslot: Timeslot;
}

export const NotesButtonsDisplay = ({ timeslot }: NotesButtonsDisplayProps) => {
    const { noteCount } = timeslot;
    const { isVisible: showEventNotesModal, toggle: toggleEventNotesModal } = useModal(false);

    const handleNotesClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        toggleEventNotesModal();
    };

    return (
        <div className="flex items-center space-x-1 2xl:space-x-4">
            <span className="ui-dashboard-note-count">
                <div className="w-12">
                    <NotesBadge noteCount={noteCount} size="medium" onClick={handleNotesClick} />
                </div>
            </span>

            {showEventNotesModal && (
                <EventNotesModal
                    eventId={timeslot.event?.id}
                    isOpen={showEventNotesModal}
                    onClose={toggleEventNotesModal}
                />
            )}

            <DashboardItemActionButtons timeslot={timeslot} />
        </div>
    );
};
